// Keep values synchronized with ScreenSize.less
export const md = 660;
export const sm = 480;
export const xs = 414;
